import { render, staticRenderFns } from "./NricImageUploadField.vue?vue&type=template&id=49e0f03c&"
import script from "./NricImageUploadField.vue?vue&type=script&lang=js&"
export * from "./NricImageUploadField.vue?vue&type=script&lang=js&"
import style0 from "./NricImageUploadField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports